import { styled } from 'styled-components';

export const FooterContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 10px;
  left: 0;

  svg {
    cursor: pointer;
  }
`;
